export default __webpack_public_path__ + "static/media/reachOut.4725d366.svg";